<template>
    <edit-string
        ref="input"
        v-model="inputValue"
        :test-id="testId"
        form
        :autocomplete="autocomplete"
        :readonly="readonly"
        :disabled="disabled"
        :loading="loading"
        :required="required"
        :rules="rulesValue"
        :error="error"
        :error-messages="errorMessagesValue"
        :label="labelValue"
        :hide-details="hideDetails"
        :hide-label="hideLabel"
        :description="descriptionValue"
        :placeholder="placeholderValue"
        :hint="hintValue"
        :name="name"
        :info="info"
        :mask="mask"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @keyup="$emit('keyup')"
        @keydown="$emit('keydown')"
        @click="$emit('click')"
    >
        <template #prepend>
            <slot name="prepend" />
        </template>
        <template #prepend-inner>
            <slot name="prepend-inner" />
        </template>
        <template #append>
            <slot name="append" />
        </template>
        <template #append-outer>
            <slot name="append-outer" />
        </template>
    </edit-string>
</template>

<script>
import BaseField from './BaseField';
export default {
    name: 'String',
    extends: BaseField
};
</script>
